import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs';

import { OFFER_SERVER_URL } from '../../config';
import { CodeValue } from '../../shared/models/code-value';
import {
	ProductCharacteristicsTranslationService
} from '../../shared/services/product-characteristics-translation.services';

const FIELD_NAMES_URL_V2 = `${ OFFER_SERVER_URL }/products:fields`;

@Injectable({ providedIn: 'root' })
export class ProductService {
	constructor(
		private readonly http: HttpClient,
		private readonly productCharacteristicsTranslationService: ProductCharacteristicsTranslationService
	) {}

	loadFieldNameTranslations(
		a2c: boolean
	) {
		const url = new URL(FIELD_NAMES_URL_V2);
		const params = url.searchParams;
		params.append('a2c', String(a2c));
		return this.http.get<CodeValue[]>(url.toString())
			.pipe(
				tap(fieldNameTranslations => {
					this.productCharacteristicsTranslationService.add(fieldNameTranslations);
				}),
				map(() => true)
			);
	}
}
